export const UPDATE_ADDRESS_MULTIPLE = "UPDATE_ADDRESS_MULTIPLE";
export const UPDATE_ADDRESS_MULTIPLE_SUCCESS =
  "UPDATE_ADDRESS_MULTIPLE_SUCCESS";
export const UPDATE_ADDRESS_MULTIPLE_FAIL = "UPDATE_ADDRESS_MULTIPLE_FAIL";

export const GET_ADDRESS_LIST = "GET_ADDRESS_LIST";
export const GET_ADDRESS_LIST_SUCCESS = "GET_ADDRESS_LIST_SUCCESS";
export const GET_ADDRESS_LIST_FAIL = "GET_ADDRESS_LIST_FAIL";

export const ADD_ADDRESS = "ADD_ADDRESS";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_FAIL = "ADD_ADDRESS_FAIL";

export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";
export const UPDATE_ADDRESS_FAIL = "UPDATE_ADDRESS_FAIL";

export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_FAIL = "DELETE_ADDRESS_FAIL";

export const ADD_VIRTUAL_LOCKER = "ADD_VIRTUAL_LOCKER";
export const ADD_VIRTUAL_LOCKER_SUCCESS = "ADD_VIRTUAL_LOCKER_SUCCESS";
export const ADD_VIRTUAL_LOCKER_FAIL = "ADD_VIRTUAL_LOCKER_FAIL";

export const GET_VIRTUAL_LOCKER = "GET_VIRTUAL_LOCKER";
export const GET_VIRTUAL_LOCKER_SUCCESS = "GET_VIRTUAL_LOCKER_SUCCESS";
export const GET_VIRTUAL_LOCKER_FAIL = "GET_VIRTUAL_LOCKER_FAIL";
